import { Field, useField, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import ImagePreview from './ImagePreview';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import WithError from '../../../../components/with-error/WithError';

import scss from './UploadModal.module.scss';

function UploadForm({ onSubmit, onCancel }) {
  const { t } = useTranslation('id8');
  const { submitting } = useFormState();
  const hiddenFileInput = useRef(null);

  const imageField = useField('image');

  const handleRemoveImage = () => {
    imageField.input.onChange(null);
    hiddenFileInput.current.value = '';
  };

  const handleOpenChooseFile = () => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      imageField.input.onChange(file);
    }
  };

  useEffect(() => {
    return () => {
      if (hiddenFileInput?.current) {
        hiddenFileInput.current.value = '';
      }
    };
  }, []);

  return (
    <form onSubmit={onSubmit} className={scss.form}>
      <WithLabel label={t('description')} variant={LABEL_STYLES.COLUMN} isBold isTwoDots>
        <Field name='description'>
          {({ input, meta }) => (
            <CommonTextarea
              name={input.name}
              value={input.value}
              onChange={input.onChange}
              onFocus={input.onFocus}
              onBlur={input.onBlur}
              disabled={submitting}
              rows='3'
              placeholder={t('enterYourDescription')}
              isError={meta.touched && meta.error}
            />
          )}
        </Field>
      </WithLabel>

      <Field name='image'>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <div className={scss.imageUploader}>
              <TooltipButton styleColor={BUTTON_STYLES.PRIMARY} onClick={handleOpenChooseFile} maxWidth={162}>
                <Icon icon={ICONS.ImportIcon} />
                {t('uploadADImage')}
              </TooltipButton>
              <input
                type='file'
                id={input.name}
                name={input.name}
                onChange={handleFileChange}
                onFocus={input.onFocus}
                onBlur={input.onBlur}
                ref={hiddenFileInput}
                style={{ display: 'none' }}
              />
              <ImagePreview image={input.value} onRemove={handleRemoveImage} />
            </div>
          </WithError>
        )}
      </Field>

      <div className={scss.actions}>
        <TooltipButton styleColor={BUTTON_STYLES.SECONDARY} onClick={onCancel} maxWidth={144}>
          {t('cancel')}
        </TooltipButton>
        <TooltipButton styleColor={BUTTON_STYLES.PRIMARY} onClick={onSubmit} maxWidth={144}>
          {t('submit')}
        </TooltipButton>
      </div>
    </form>
  );
}

export default UploadForm;
